import React, {useEffect, useState} from "react";
import {useCustomers} from "../../../../providers/CustomerProvider";
import {Dropdown, Form, Accordion, Icon, Checkbox, Button} from "semantic-ui-react";
import {useReport} from "../../../../providers/ReportProvider";
import styles from './SyrxReportForm.module.css';
import {useNavigate} from 'react-router';

const addAosComponent = (aosComponent) => {
    return {
        id: aosComponent.id,
        parent_id: aosComponent.parent_id,
        name: aosComponent.name,
        num: aosComponent.num,
        children: [],
        selected: false
    }
}

const addAosComponentsToParent = (aosComponents, parent) => {
    const children = aosComponents.filter(x => x.parent_id === parent.id);
    children.forEach(child => {
        const nestedChild = addAosComponent(child);
        parent.children.push(nestedChild);

        addAosComponentsToParent(aosComponents, nestedChild);
    });
}

const orderAosComponents = (aosComponents) => {
    const ordered = [];
    var root = aosComponents.find(x => x.id === "db1df480-4401-4402-98d9-70d35220041e");

    ordered.push(addAosComponent(root));
    addAosComponentsToParent(aosComponents, ordered[0]);

    return ordered;
}


export const SyrxReportForm = () => {
    const {customersList, getAllCustomers} = useCustomers();
    const {listAosComponents} = useReport();
    const {createSyrxReport} = useReport();
    const [nestedComponents, setNestedComponents] = useState([]);
    const [flatComponents, setFlatComponents] = useState([]);
    const navigate = useNavigate();

    const [customer, setCustomer] = useState(null);
    const [reportName, setReportName] = useState('');


    useEffect(() => {
        getAllCustomers();

        listAosComponents("db1df480-4401-4402-98d9-70d35220041e").then(data => {
            setFlatComponents(data.data.map(obj => ({ ...obj,
                index: obj.num,
                active: false,
                checked: false
            })))
            setNestedComponents(orderAosComponents(data.data));
        });
    }, [getAllCustomers, listAosComponents]);

    const handleSubmit = () => {
        if(reportName !== '' && customer !== null && flatComponents.filter(res=>res.checked).length > 0) {
            createSyrxReport(
                reportName,
                customer.id,
                customer.groupId,
                flatComponents.filter(res=>res.checked).map(ele=>ele.id)).then(
                function(value) {
                    navigate(`/reports?customerId=${customer.id}`);
                },
                function(error) {
                    console.error(error)
                }
            );
        }
    }

    const handleClick = (e, titleProps) => {
        const componentIndex = titleProps.component.num;

        let temp = [...flatComponents];
        let tempComponent = temp.find(x => x.num === componentIndex)
        tempComponent.active = !tempComponent.active;

        setFlatComponents(temp)
    }

    const handleCheckboxClick = (e, titleProps) => {
        const compnentFromArr = flatComponents.find(x => x.index === titleProps.component.num);

        const temp = [...flatComponents];
        temp.find(x => x.index === compnentFromArr.index).checked = titleProps.checked;

        if(!e.shiftKey) {
            let enumArry = temp.filter(com => com.num.includes(compnentFromArr.num));
            enumArry.forEach(com => {
                com.checked = titleProps.checked;
            });
        }

        setFlatComponents(temp)
    }


    let c = 0;
    const DisplayAosComponents = (props) => {
        const parent = props.aosComponent[0];
            if(parent.children.length > 0 && flatComponents.length > 0 ) {
                c++;
                return (
                    <>
                        <Accordion.Title
                            active={flatComponents.find(x => x.index === parent.num).active}
                            component={parent}
                            className={styles.componentTitleBold}
                        >
                            <Checkbox
                                component={parent}
                                label={`${parent.name} ${parent.num}`}
                                checked={flatComponents.find(x => x.index === parent.num).checked}
                                onClick={handleCheckboxClick}
                            />
                            <Icon
                                component={parent}
                                name='dropdown'
                                onClick={handleClick}
                            />
                        </Accordion.Title>
                        <Accordion.Content
                            active={flatComponents.find(x => x.index === parent.num).active}
                            style={{paddingLeft:(c+'em')}}
                            className={styles.accordianContent}>
                            <Accordion>
                            {
                                parent.children.map(child => {
                                    return (
                                        <DisplayAosComponents aosComponent={[child]}/>
                                    )
                                })
                            }
                            </Accordion>
                        </Accordion.Content>
                    </>

                )
            }
            else{
                c = 0;
                return (
                    <div className={styles.componentTitle}>
                        <Checkbox
                            component={parent}
                            label={`${parent.name} ${parent.num}`}
                            checked={flatComponents.find(x => x.index === parent.num).checked}
                            onClick={handleCheckboxClick}
                        />
                    </div>
                )
            }
    };

    return(
        <>
            <Form>
                <Form.Group>
                    <Form.Input
                        label={'Report Name'}
                        onChange={(e, value) => setReportName(value.value)}
                        fluid
                        width={6}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Field
                        label={'Customer'}
                        control={Dropdown}
                        fluid
                        selection
                        options={customersList.map(x => {
                            const text =
                                x?.firstname && x?.lastname
                                    ? `${x?.companyName} (${x?.firstname} ${x?.lastname})`
                                    : x?.companyName;
                            return {
                                key: x?.id,
                                text: text,
                                value: x?.id,
                            };
                        })}
                        style={{height: '38px'}}
                        onChange={(e, selected) => {
                            const customer = customersList.find(x => x.id === selected.value);
                            setCustomer(customer);
                        }}
                        width={6}
                        search
                    />
                </Form.Group>

                <div>
                    <Accordion>
                        {
                            nestedComponents.length > 0 &&
                            <>
                                <div className={styles.shiftDisclaimer}>
                                    Hold Shift while clicking checkbox to select without children
                                </div>
                                <div className={styles.componentContainer}>
                                    <DisplayAosComponents aosComponent={nestedComponents}/>
                                </div>
                                <div>
                                    <Button
                                        onClick={handleSubmit}
                                        primary
                                    >
                                        Create Report
                                    </Button>
                                </div>
                            </>

                        }
                    </Accordion>
                </div>
            </Form>
        </>
    );
};